import React from 'react';
import {Card, CardText} from 'material-ui/Card';

const styles = {
  card:{
    margin:10,
    textAlign:'center'
  },
  cardheader:{
    paddingBottom:0,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  }
};

export default class ReferencesCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardText>
          <div>
            Available Upon Request
          </div>

        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReferencesCard.js